import { css } from '@emotion/react';
import { genAIGradient, gray1 } from 'styles/global_defaults/colors';
import { semiBoldFontWeight, textSmallFontSize } from 'styles/global_defaults/fonts';
import { halfSpacing, quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';

const aiInsightsPillStyles = css`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: ${quarterSpacing}px;
  background: linear-gradient(315deg, rgba(220, 253, 253, 0.30) 0%, rgba(247, 251, 232, 0.30) 99.28%);
  border: none;
  padding: ${quarterSpacing}px ${halfSpacing}px;
  border-radius: ${standardSpacing}px;
  font-size: ${textSmallFontSize}px;
  font-weight: ${semiBoldFontWeight};
  color: ${gray1};
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: ${genAIGradient};
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  &:hover {
    opacity: 0.9;
  }
`;

export default aiInsightsPillStyles;
